<template>
  <el-dialog @open="open" style="text-align: center" title="Novo Representante" :visible.sync="visibility" :before-close="beforeClose" :close-on-click-modal="false" append-to-body width="40%">
    <el-form :model="representante" :rules="validacao" ref="form" size="small" label-position="top" style="margin: -15px 10px 0px 0px;" hide-required-asterisk :show-message="false">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="representante.nome"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Data de Nascimento">
            <el-date-picker
              auto-complete="off"
              v-model="representante.dataNascimento"
              v-mask="'##/##/####'"
              type="date"
              format="dd/MM/yyyy"
              value-format="dd/MM/yyyy"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="CPF" prop="cpf">
            <el-input v-model="representante.cpf" v-mask="['###.###.###-##']" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="RG">
            <el-input v-model="representante.rg"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Estado Civil">
            <el-select v-model="representante.estadoCivil" value-key="data" style="width: 100%" clearable @clear="representante.estadoCivil = undefined">
              <el-option v-for="item in estadoCivil" :key="item.data" :label="item.label" :value="item.data"/>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="E-mail">
            <el-input v-model="representante.email" />
          </el-form-item>
        </el-col>

      </el-row>

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="Profissão">
            <el-input v-model="representante.profissao"/>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="Nacionalidade">
            <el-input v-model="representante.nacionalidade"/>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
      
        <el-col :md="19" :lg="20">
          <el-form-item label="Endereço" prop="endereco">
            <el-input auto-complete="off" v-model="representante.endereco"></el-input>
          </el-form-item>
        </el-col>

        <el-col :md="5" :lg="4">
          <el-form-item label="Número">
            <el-input auto-complete="off" v-model="representante.numeroEndereco"></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="18" :lg="19">
          <el-form-item label="Complemento">
            <el-input auto-complete="off" v-model="representante.complementoEndereco"></el-input>
          </el-form-item>
        </el-col>

        <el-col :md="5" :lg="5">
          <el-form-item label="CEP">
            <el-input auto-complete="off" v-model="representante.cepEndereco" v-mask="'#####-###'"></el-input>
          </el-form-item>
         </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :md="5" :lg="4">
           <el-form-item label="Estado" prop="estado">
              <el-select v-model="representante.estado" value-key="id" placeholder="" filterable default-first-option style="width: 100%">
                <el-option v-for="item in estados" :key="item.id" :label="item.sigla" :value="item"/>
              </el-select>
            </el-form-item>
        </el-col>
                              
        <el-col :md="8" :lg="10">
          <el-form-item label="Cidade">
            <el-input auto-complete="off" v-model="representante.cidade"></el-input>
          </el-form-item>
         </el-col>

        <el-col :md="8" :lg="10">
          <el-form-item label="Bairro">
            <el-input auto-complete="off" v-model="representante.bairro"></el-input>                               
          </el-form-item>
        </el-col>
      </el-row>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button v-if="!representante.id" @click="adicionar" type="primary" size="small" class="btn-box-shadow">Adicionar</el-button>
      <el-button v-if="representante.id" @click="gravar" type="primary" size="small" class="btn-box-shadow">Gravar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ESTADOS, ESTADO_CIVIL } from '../../util/constantes';
import { mapActions } from 'vuex';
export default {
  props: {
    visibility: Boolean,
    representanteRecuperado: Object
  },
  data() {
    return {
      validacao: {
        nome: [
          { type: "string", required: true, whitespace: true, message: "Nome é obrigatório" }
        ],
        cpf: [
          { type: "string", required: true, whitespace: true, len: 14, message: "CPF é obrigatório" }
        ],
      },
      representante: {
        nome: undefined,
        dataNascimento: undefined,
        cpf: undefined,
        rg: undefined,
        profissao: undefined,
        nacionalidade: undefined,
        estadoCivil: undefined,
        email: undefined,
        endereco: undefined,
        numeroEndereco: undefined,
        complementoEndereco: undefined,
        cepEndereco: undefined,
        bairro: undefined,
        cidade: undefined,
        estado: { id: 0 },
      }
    }
  },
  computed: {
     estados() { 
      return ESTADOS.filter(estado => { return estado.pais.id === 1 });
    },
    estadoCivil(){
      return ESTADO_CIVIL;
    }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('alugueisClientesStore', [
      'atualizarRepresentante'
    ]),
    reset() {
      this.representante = {
        nome: undefined,
        dataNascimento: undefined,
        cpf: undefined,
        rg: undefined,
        profissao: undefined,
        nacionalidade: undefined,
        estadoCivil: undefined,
        email: undefined,
        endereco: undefined,
        numeroEndereco: undefined,
        complementoEndereco: undefined,
        cepEndereco: undefined,
        bairro: undefined,
        cidade: undefined,
        estado: { id: 0 }
      };
      this.$refs['form'].resetFields();
    },
    adicionar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          let payload = {
            nome: this.representante.nome,
            dataNascimento: this.representante.dataNascimento,
            cpf: this.representante.cpf,
            rg: this.representante.rg,
            profissao: this.representante.profissao,
            nacionalidade: this.representante.nacionalidade,
            estadoCivil: this.representante.estadoCivil,
            email: this.representante.email,
            endereco: this.representante.endereco,
            numeroEndereco: this.representante.numeroEndereco,
            complementoEndereco: this.representante.complementoEndereco,
            cepEndereco: this.representante.cepEndereco,
            bairro: this.representante.bairro,
            cidade: this.representante.cidade,
            estado: this.representante.estado
          };

          this.fechar(payload);
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      });
    },
    gravar() {
      this.$refs['form'].validate((valid) => {
        if(valid) {
          let payload = {
            id: this.representante.id,
            nome: this.representante.nome,
            dataNascimento: this.representante.dataNascimento,
            cpf: this.representante.cpf,
            rg: this.representante.rg,
            profissao: this.representante.profissao,
            nacionalidade: this.representante.nacionalidade,
            estadoCivil: this.representante.estadoCivil,
            email: this.representante.email,
            endereco: this.representante.endereco,
            numeroEndereco: this.representante.numeroEndereco,
            complementoEndereco: this.representante.complementoEndereco,
            cepEndereco: this.representante.cepEndereco,
            bairro: this.representante.bairro,
            cidade: this.representante.cidade,
            estado: this.representante.estado
          };

          this.showLoading();
          this.atualizarRepresentante(payload)
          .then(resultado => {
            switch (resultado.status) {
              case 'SUCESSO':
                this.$message.success(resultado.mensagem);
                break;   
              case 'ERRO':
                this.$message.error(resultado.mensagem);
                break;
            }
            this.hideLoading();
          }).catch(() => {
            this.$message.error('Ocorreu um erro, tente novamente');
            this.hideLoading();
          });

          this.fechar(undefined, true);
        } else {
          this.$message.error("Preencha todos os campos obrigatórios");
        }
      })
    },
    beforeClose(){
      this.fechar();
    },
    fechar(representante, isRecuperarCliente = false) {
      const args = { representante: representante, isRecuperarCliente }
      this.$emit('close', args);
      this.reset();
    },
    open() {
      if(this.representanteRecuperado && this.representanteRecuperado.id > 0) {
        this.representante = this.representanteRecuperado
      }
    }
  }
}
</script>

